

































import { computed, defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'BlockFooterBanner',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    appInvite: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    imageMobile: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const style = computed(() => ({
      '--footer-banner-background': props.backgroundColor,
    }))

    const component = computed(() => {
      if (!props.link) return { type: 'div', props: null }
      return { type: 'a', props: { href: props.link, target: '_blank' } }
    })

    const sizes = { sm: [1161, 572], md: [1161, 572], lg: [1161, 572] }

    return {
      style,
      sizes,
      component,
    }
  },
})
